import { Component, inject, input, InputSignal, TemplateRef, viewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';

export type AlertType = 'success' | 'info' | 'error' | 'warning'

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  imports: [NzAlertModule],
})
export class AlertComponent {
  public translateService: TranslateService = inject(TranslateService);
  
  public type: InputSignal<AlertType> = input<AlertType>('info');
  public message: InputSignal<string> = input.required<string>();
  public isIconActive: InputSignal<boolean> = input<boolean>(true);
  public description: InputSignal<string> = input('');
  public alertTemplate = viewChild.required<TemplateRef<any>>('alert');
}
